module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/candidate/onlinepayment/onlinepayment.component.scss
// module id = ./src/app/candidate/onlinepayment/onlinepayment.component.scss
// module chunks = main